import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Clock, Shield, Activity, FileText } from 'lucide-react';
export function ProductDetailsSection() {
  const features = [{
    icon: <Activity className="w-6 h-6" data-id="element-111" />,
    title: 'Mapa 3E',
    desc: 'Para ubicarte en 3 minutos y saber qué necesita tu cuerpo hoy.'
  }, {
    icon: <Clock className="w-6 h-6" data-id="element-112" />,
    title: 'Protocolos AM/PM/Noche',
    desc: 'Rutinas cortas (7-12 min) para arrancar estable, cortar la escalada y apagar la alarma nocturna.'
  }, {
    icon: <Shield className="w-6 h-6" data-id="element-113" />,
    title: 'Plan de Rescate',
    desc: 'Qué hacer en 90 segundos cuando sentís que vas a explotar.'
  }, {
    icon: <FileText className="w-6 h-6" data-id="element-114" />,
    title: 'Tracker 14 Días',
    desc: 'Para ver patrones reales sin obsesionarte y recuperar el control.'
  }, {
    icon: <BookOpen className="w-6 h-6" data-id="element-115" />,
    title: 'Guión de Consulta',
    desc: 'Las palabras exactas para pedir ayuda médica sin que te minimicen.'
  }];
  return <section className="py-24 px-4 bg-white" data-id="element-116">
      <div className="max-w-5xl mx-auto" data-id="element-117">
        <FadeIn className="text-center mb-16" data-id="element-118">
          <h2 className="text-4xl md:text-5xl text-[#2D2A26] mb-6" data-id="element-119">
            Presento: Ansiedad Hormonal <br data-id="element-120" />
            <span className="text-[#1A6B5A] italic text-3xl md:text-4xl block mt-2" data-id="element-121">
              Protocolo 14 Días (Perimenopausia 30+)
            </span>
          </h2>
          <p className="text-lg text-[#6B6560] max-w-2xl mx-auto" data-id="element-122">
            Un ebook práctico (PDF) diseñado para ser tu ancla cuando todo se
            siente inestable.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-123">
          <FadeIn className="order-2 md:order-1" data-id="element-124">
            <div className="space-y-6" data-id="element-125">
              {features.map((feature, idx) => <div key={idx} className="flex items-start p-4 rounded-lg hover:bg-[#FDF8F3] transition-colors duration-300" data-id="element-126">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#1A6B5A]/10 flex items-center justify-center text-[#1A6B5A] mt-1" data-id="element-127">
                    {feature.icon}
                  </div>
                  <div className="ml-4" data-id="element-128">
                    <h4 className="text-lg font-bold text-[#2D2A26] font-serif" data-id="element-129">
                      {feature.title}
                    </h4>
                    <p className="text-[#6B6560] leading-relaxed" data-id="element-130">
                      {feature.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </FadeIn>

          <FadeIn delay={0.2} className="order-1 md:order-2 flex justify-center" data-id="element-131">
            <div className="relative w-full max-w-sm" data-id="element-132">
              <div className="absolute inset-0 bg-[#C4785B] rounded-2xl rotate-3 opacity-20 transform scale-105" data-id="element-133"></div>
              <img src="https://cdn.magicpatterns.com/uploads/kt4qyRLUeRG9wHB7aDuWSb/private_openrouter-generated-image-1770377597638.png" alt="Vista previa del ebook" className="relative z-10 rounded-xl shadow-2xl w-full h-auto object-cover border border-[#E8DED5]" data-id="element-134" />
            </div>
          </FadeIn>
        </div>

        <FadeIn className="mt-20 p-8 bg-[#FDF8F3] rounded-xl border border-[#E8DED5] text-center" data-id="element-135">
          <h3 className="text-xl font-bold text-[#2D2A26] mb-2 font-serif" data-id="element-136">
            Qué vas a notar en 14 días
          </h3>
          <p className="text-[#6B6560] mb-6" data-id="element-137">
            No te vendo magia. Te vendo claridad.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-138">
            {["Más capacidad de 'volver'", 'Menos sorpresa', 'Mejor higiene de sueño', 'Menos escalada nocturna'].map((item, i) => <span key={i} className="px-4 py-2 bg-white rounded-full text-[#1A6B5A] text-sm font-medium shadow-sm border border-[#1A6B5A]/10" data-id="element-139">
                {item}
              </span>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}